// test1972
(1972 && 0);
